import { logger } from '@src/logger';
import { ClientLogsCollection } from '@shared/logger';
export function storeFeedback({ action, actionModifier, details }) {
    logger.clientLogger.info({
        collection: ClientLogsCollection.Feedback,
        action,
        actionModifier,
        details
    });
}
